export default __webpack_public_path__ + "assets/images/d1ae80c1c698601e071b5d07a0f35d8e.png";